import z from "zod/v4";
import { TenantIdCodec, SiteIdCodec } from "@visioni/a3s-schema/codecs";

/** A site upsert as observed from a hub event or backfill. */
export const SiteChange = z.object({
  action: z.literal("set"),
  siteId: SiteIdCodec,
  siteName: z.string(),
  timezone: z.string().nullable(),
  address: z.string().nullable(),
  crossStreet: z.string().nullable(),
  branchId: z.number(),
  branchName: z.string(),
  tenant: TenantIdCodec,
});
export type SiteChange = z.infer<typeof SiteChange>;
